const NavBar = ({navdata, ...props}) => {
    return (
        <nav className="navbar hidden-xs">
                <ul className="nav navbar-nav">
                    {navdata.map((n) => {
                        return <li style={n.style} className={n.active} key={n.id}><a href={n.location} onClick={() => props.handleMenuSelection(n.id)} rel="noreferrer"><span>{n.name}</span></a></li>
                    })}
                </ul>
        </nav>
    );
}

export default NavBar;